import { AsyncPipe, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Layout } from 'src/app/api/v1/models';
import { ConfigRepository } from '../../shared/repositories/config.repository';
import {
  DefaultCategoryPageComponent
} from '../../layout/default/default-category-page/default-category-page.component';
import { FreshCategoryPageComponent } from '../../layout/fresh/fresh-category-page/fresh-category-page.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  standalone: true,
  imports: [
    AsyncPipe,
    NgSwitch,
    NgSwitchCase,
    DefaultCategoryPageComponent,
    FreshCategoryPageComponent,
  ]
})
export class CategoryComponent{
  constructor(
    private config: ConfigRepository,
  ) {}
  @Input() slug: string;

  layout$: Observable<Layout> = this.config.layout$;
  layouts = Layout;
}
